module.exports = __webpack_public_path__ + "static/big_unicorn_fade-4f3827a2edc212ca306a4a39099b707e.png";